module.exports = __webpack_public_path__ + "img/flamandzki.f68369df.jpg";